// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".p-credit-cards h2{font-size:var(--fs-600)}.p-credit-cards p{font-size:var(--fs-400)}.p-credit-cards>.block1{padding:calc(var(--fs-700)*6) 0}.p-credit-cards>.block1>.common-subcontainer{padding:0 20%}.p-credit-cards>.block1>.common-subcontainer>h2{margin-bottom:var(--fs-700)}.p-credit-cards>.block1>.common-subcontainer>p{margin-bottom:var(--fs-500)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
